import React from 'react';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import InputLabel from '@mui/material/InputLabel';
import './textField.scss';

const CommonTextField = ({
  label,
  placeholder,
  value,
  onChange,
  variant,
  textCss,
  maxLength,
  autoFocus,
  size,
  id,
  disabled,
  multiline = false,
  rows,
  maxLengthCount,
  error,
  helperText,
  textFieldClassName,
  sx,
  InputProps,
}) => {
  const letterCount = value?.length;

  return (
    <div className={`text-component ${textCss}`}>
      <InputLabel className="input-label">{label}</InputLabel>
      <TextField
        className={textFieldClassName || 'text-field'}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        variant={variant}
        fullWidth
        InputLabelProps={{ shrink: true }}
        autoFocus={autoFocus}
        inputProps={{ style: { fontSize: '12px' },
          maxLength: maxLengthCount}}
        size={size}
        id={id}
        disabled={disabled}
        multiline={multiline}
        rows={rows}
        error={error}
        helperText={helperText}
        sx={sx}
        InputProps={InputProps}
      />
      {maxLength ? (
        <div className="letter-count">{`${letterCount}/${maxLength}`}</div>
      ) : (
        ''
      )}
    </div>
  );
};

CommonTextField.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  onChange: PropTypes.any.isRequired,
  variant: PropTypes.string,
  textCss: PropTypes.string,
  textFieldClassName: PropTypes.string,
  maxLength: PropTypes.number,
  autoFocus: PropTypes.bool.isRequired,
  size: PropTypes.string.isRequired,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  maxLengthCount: PropTypes.number,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  sx: PropTypes.any,
  InputProps: PropTypes.any,
};

export default CommonTextField;
